var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conatiner-checkout-summary"},[_c('data-summary-payment',{attrs:{"data-response":_vm.dataSummaryPayment.pedido,"products":_vm.dataSummaryPayment.pedido.productos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }